import React from 'react';
import TalentCandidateScopeProvider from "./TalentCandidateScopeProvider";
import {ProjectPositionProvider} from "../../../providers/ProjectPositionProvider";
import ManageCandidateScopeTable from "./ManageCandidateScopeTable";
import {useParams} from "react-router-dom";

const ManageCandidateScopeLayout = () => {

    const {roleId} = useParams();

    if (!roleId) {
        return null;
    }
    return (
        <ProjectPositionProvider positionId={parseInt(roleId)}>
            <TalentCandidateScopeProvider>
                <ManageCandidateScopeTable/>
            </TalentCandidateScopeProvider>
        </ProjectPositionProvider>
    );
};

export default ManageCandidateScopeLayout;